import React, { useState, useEffect } from "react";
import GenresTable from "./components/GenresTable";
import api from "services/api";

const Genres = () => {
  const [genres, setGenres] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [name, setName] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "success" });

  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: "", type: "success" }), 3000);
  };

  const fetchGenres = async () => {
    try {
      const res = await api.getGenres();
      if (Array.isArray(res)) setGenres(res);
    } catch (err) {
      console.error("Failed to fetch genres:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGenres();
  }, []);

  const handleAdd = () => {
    setEditData(null);
    setName("");
    setShowModal(true);
  };

  const handleEdit = (genre) => {
    setEditData(genre);
    setName(genre.name);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this genre?")) return;
    try {
      await api.deleteGenre(id);
      showToast("Genre deleted successfully!");
      fetchGenres();
    } catch (error) {
      showToast("Failed to delete genre", "error");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editData) {
        await api.updateGenre(editData.id, { name });
        showToast("Genre updated successfully!");
      } else {
        await api.createGenre({ name });
        showToast("Genre created successfully!");
      }
      setShowModal(false);
      fetchGenres();
    } catch (error) {
      showToast(error.message || "Failed to save genre", "error");
    }
  };

  return (
    <div>
      <div className="mt-5 flex w-full justify-end">
        <button
          onClick={handleAdd}
          className="linear rounded-[20px] bg-brand-500 px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
        >
          + Add New Genre
        </button>
      </div>

      <div className="mt-5 grid h-full grid-cols-1 gap-5">
        <GenresTable tableData={genres} onEdit={handleEdit} onDelete={handleDelete} />
      </div>

      {showModal && (
        <div className="fixed inset-0 z-[999] flex items-center justify-center p-4" style={{ backgroundColor: 'rgba(0,0,0,0.6)' }}>
          <div className="w-full max-w-md rounded-[20px] bg-white p-6 shadow-xl dark:!bg-navy-800">
            <h3 className="mb-4 text-xl font-bold text-navy-700 dark:text-white">
              {editData ? "Edit Genre" : "Add New Genre"}
            </h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="mb-1 block text-sm font-medium text-navy-700 dark:text-white">
                  Genre Name
                </label>
                <input
                  type="text"
                  required
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none border-gray-200 dark:!border-white/10 dark:text-white"
                  placeholder="e.g. Action"
                />
              </div>
              <div className="flex justify-end gap-2">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="linear rounded-[20px] bg-gray-100 px-4 py-2 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-200 dark:bg-white/10 dark:text-white dark:hover:bg-white/20"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="linear rounded-[20px] bg-brand-500 px-4 py-2 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {toast.show && (
        <div className={`fixed top-10 left-1/2 -translate-x-1/2 z-[1000] flex items-center rounded-xl px-6 py-3 text-sm font-bold text-white shadow-xl transition-all ${toast.type === 'success' ? 'bg-green-500' : 'bg-red-500'}`}>
          {toast.message}
        </div>
      )}
    </div>
  );
};

export default Genres;
